// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Account Connections — scoped .acct-* */

.acct-page {
  width: 100%;
  min-height: 100%;
  padding: 35px 24px 48px;
  max-width: 1220px;
  margin: 0 auto;
}

.acct-page *,
.acct-page *::before,
.acct-page *::after {
  box-sizing: border-box;
}

.acct-page__crumbs {
  margin-bottom: 18px;
}

.acct-page__crumbList {
  list-style: none;
  padding: 0;
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #8e939c;
  font-size: 15px;
  font-weight: 500;
}

.acct-page__crumbItem--active {
  color: #d9d9d9;
  font-weight: 600;
}

body.light_theme .acct-page__crumbItem--active {
  color: #101828;
}

.acct-page__crumbSep {
  color: #8e939c;
}

.acct-page__crumbLink {
  border: none;
  background: transparent;
  padding: 0;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.acct-page__crumbLink:hover {
  text-decoration: underline;
  text-underline-offset: 3px;
}

.acct-page__title {
  margin: 0 0 12px;
  font-size: 36px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #e1e1e1;
}

body.light_theme .acct-page__title {
  color: #101828;
}

.acct-page__subtitle {
  margin: -12px 0 22px;
  font-size: 14px;
  color: #8e939c;
  font-weight: 500;
  line-height: 1.5;
}

.acct-page__hint {
  margin: -14px 0 18px;
  font-size: 13px;
  color: #8e939c;
  line-height: 1.45;
}

.acct-page__banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin: -8px 0 20px;
  padding: 12px 14px;
  border-radius: 10px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  color: #9a3412;
  font-size: 13px;
  font-weight: 500;
}

.acct-page__bannerBtn {
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid rgba(154, 52, 18, 0.35);
  background: #fff;
  color: #9a3412;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.acct-page__bannerBtn:hover {
  background: #fffbeb;
}

/* Connection cards */
.acct-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 30px 40px;
}

.acct-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
  border-radius: 12px;
  background: #f5f6f70a;
  border: 1px solid #eef2f61a;
}

body.light_theme .acct-card {
  background: #f5f6f7;
  border: 1px solid #eef2f6;
}

.acct-card__left {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  min-width: 0;
}

.acct-card__logo {
  width: 26px;
  padding: 4px;
  height: 26px;
  flex-shrink: 0;
  background-color: #E9E9E9;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
}

.acct-card__logo svg {
  display: block;
}

.acct-card__body {
  min-width: 0;
}

.acct-card__title {
  font-size: 16px;
  font-weight: 600;
  color: #e7e7e7;
  margin: 0 0 4px;
}

body.light_theme .acct-card__title {
  color: #101828;
}

.acct-card__meta {
  font-size: 12px;
  font-weight: 500;
  color: #6A7282;
  margin: 0;
}

.acct-card__btn {
  flex-shrink: 0;
  height: 40px;
  padding: 0 20px;
  border-radius: 999px;
  border: none;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
}

.acct-card__btn--disconnect {
  background: #e8eaed;
  color: #101828;
}

.acct-card__btn--connect {
  background: #2d2e32;
  color: #ffffff;
  font-weight: 500;
}

/* Select unavailable */
.acct-unavail {
  max-width: 560px;
  margin: 0 auto;
}

.acct-unavail__title {
  margin: 0 0 10px;
  font-size: 36px;
  font-weight: 600;
  color: #f0f0f0;
  text-align: left;
}

body.light_theme .acct-unavail__title {
  color: #101828;
}

.acct-unavail__sub {
  margin: 0 0 22px;
  font-size: 16px;
  font-weight: 500;
  color: #84888C;
  text-align: left;
  line-height: 1.5;
}

.acct-unavail__choice {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 16px 18px;
  background: #f3f4f61f;
  border: 1px solid #e5e7eb6b;
  border-radius: 10px;
  cursor: pointer;
  text-align: left;
  margin-bottom: 16px;
}

body.light_theme .acct-unavail__choice {
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
}

.acct-unavail__choice.is-selected {
  border-color: rgba(172, 138, 80, 0.45);
}

.acct-unavail__choiceLeft {
  display: flex;
  align-items: center;
  gap: 12px;
}

.acct-unavail__choiceIcon {
  font-size: 22px;
  color: #cfcfcf;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

body.light_theme .acct-unavail__choiceIcon {
  color: #4a5565;
}

.acct-unavail__choiceTitle {
  font-size: 14px;
  font-weight: 700;
  color: #f1f1f1;
}

body.light_theme .acct-unavail__choiceTitle {
  color: #101828;
}

.acct-unavail__choiceSub {
  font-size: 12px;
  color: #8e939c;
  margin-top: 3px;
}

.acct-unavail__radio {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #d1d5db;
  background: #fff;
  flex-shrink: 0;
}

.acct-unavail__choice.is-selected .acct-unavail__radio {
  border-color: #101828;
  box-shadow: inset 0 0 0 2px #101828;
}

.acct-unavail__confirm {
  width: 100%;
  height: 50px;
  border-radius: 999px;
  border: none;
  background: #a3a3a3;
  margin-top: 10px;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  cursor: not-allowed;
}

.acct-unavail__confirm.is-enabled {
  background: #2d2e32;
  cursor: pointer;
}

.acct-unavail__how {
  display: block;
  width: 100%;
  margin-top: 20px;
  border: none;
  background: transparent;
  font-size: 16px;
  font-weight: 600;
  color: #ac8a50;
  /* text-decoration: underline; */
  text-underline-offset: 3px;
  cursor: pointer;
}

/* Add Email */
.acct-add {
  max-width: 560px;
  margin: 0 auto;
}

.acct-add__title {
  margin: 0 0 10px;
  font-size: 28px;
  font-weight: 700;
  color: #f3f3f3;
}

body.light_theme .acct-add__title {
  color: #101828;
}

.acct-add__sub {
  margin: 0 0 22px;
  font-size: 14px;
  color: #8e939c;
  line-height: 1.5;
}

.acct-field {
  margin-bottom: 18px;
}

.acct-label {
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #e0e0e0;
  margin-bottom: 6px;
}

body.light_theme .acct-label {
  color: #101828;
}

.acct-inputWrap {
  position: relative;
}

.acct-input {
  width: 100%;
  height: 48px;
  border-radius: 8px;
  border: 1px solid #e5e7eb14;
  background: #ffffff14;
  padding: 0 14px;
  font-size: 13px;
  font-weight: 600;
  color: #e5e5e5;
  outline: none;
}

body.light_theme .acct-input {
  border: 1px solid #e5e7eb;
  background: #ffffff;
  color: #101828;
}

.acct-input--code {
  padding-right: 88px;
}

.acct-input::placeholder {
  color: #9ca3af;
}

.acct-getCode {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  font-size: 12px;
  font-weight: 700;
  color: #ac8a50;
  cursor: pointer;
}

.acct-add__submit {
  width: 100%;
  height: 48px;
  margin-top: 8px;
  border: none;
  border-radius: 999px;
  background: #a3a3a3;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  cursor: not-allowed;
}

.acct-add__submit.is-enabled {
  background: #2d2e32;
  cursor: pointer;
}

/* Modals */
.acct-modalOverlay {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 20%);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding: 18px; */
  z-index: 100000030;
}

body.light_theme .acct-modalOverlay {
  background: rgb(255 255 255 / 20%);
}

.acct-emailModal {
  width: 539px;
  max-width: 92vw;
  background: #1e2329;
  border-radius: 14px;
  border: 1px solid #2b3139;
  box-shadow: 0 28px 60px rgba(0, 0, 0, 0.5);
  padding: 22px 22px 0;
  position: relative;
  text-align: left;
}

body.light_theme .acct-emailModal {
  background: #fff;
  border: 1px solid #E1E1E1;
  box-shadow: 0 28px 60px rgba(15, 23, 42, 0.18);
}

.acct-emailModal__close {
  position: absolute;
  top: 14px;
  right: 16px;
  width: 34px;
  height: 34px;
  border: none;
  background: transparent;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  border-radius: 8px;
  color: #eaecef;
}

body.light_theme .acct-emailModal__close {
  color: #111827;
}

.acct-emailModal__close:hover {
  background: rgba(255, 255, 255, 0.1);
}

body.light_theme .acct-emailModal__close:hover {
  background: rgba(17, 24, 39, 0.06);
}

.acct-emailModal__title {
  margin: 0 0 8px;
  padding-right: 40px;
  font-size: 24px;
  font-weight: 600;
  color: #eaecef;
}

body.light_theme .acct-emailModal__title {
  color: #101828;
}

.acct-emailModal__sub {
  margin: 0 0 18px;
  font-size: 16px;
  line-height: 1.45;
  font-weight: 500;
  color: #84888C;
}

body.light_theme .acct-emailModal__sub {
  color: #6A7282;
}

.acct-emailModal__submit {
  width: 100%;
  height: 50px;
  border: none;
  border-radius: 999px;
  background: #a3a3a3;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  cursor: not-allowed;
  margin-top: 26px;
}

.acct-emailModal__submit.is-enabled {
  background: #2d2e32;
  cursor: pointer;
}

.acct-emailModal__link {
  display: block;
  width: 100%;
  margin: 20px 0 20px;
  border: none;
  background: transparent;
  text-align: center;
  font-size: 15px;
  font-weight: 500;
  color: #ac8a50;
  /* text-decoration: underline; */
  text-underline-offset: 3px;
  cursor: pointer;
}

.acct-emailModal__footer {
  border-top: 1px solid #2b3139;
  padding: 14px 0 16px;
  margin: 0 -22px;
  padding-left: 22px;
  padding-right: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 14px;
  color: #9ca3af;
  font-weight: 500;
}

body.light_theme .acct-emailModal__footer {
  border-top-color: #f4f4f4;
}

.acct-emailModal__footerIcon {
  width: 18px;
  height: 18px;
  display: block;
  object-fit: contain;
  flex-shrink: 0;
}

/* Confirm reset modal */
.acct-resetModal {
  width: 628px;
  max-width: 92vw;
  background: #1e23297d;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border-radius: 16px;
  border: 1px solid #2b3139;
  box-shadow: 0 28px 60px rgba(0, 0, 0, 0.5);
  padding: 22px 24px 22px;
  position: relative;
  text-align: center;
}

body.light_theme .acct-resetModal {
  background: rgb(255 255 255 / 20%);
  border: 1px solid #E1E1E1;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
}

.acct-resetModal__close {
  position: absolute;
  top: 12px;
  right: 14px;
  width: 34px;
  height: 34px;
  border: none;
  background: transparent;
  font-size: 22px;
  cursor: pointer;
  border-radius: 8px;
  color: #eaecef;
}

body.light_theme .acct-resetModal__close {
  color: #111827;
}

.acct-resetModal__close:hover {
  background: rgba(255, 255, 255, 0.1);
}

body.light_theme .acct-resetModal__close:hover {
  background: rgba(17, 24, 39, 0.06);
}

.acct-resetModal__art {
  margin: 8px auto 14px;
  max-width: 200px;
}

.acct-resetModal__art img,
.acct-resetModal__art svg {
  width: 100%;
  height: auto;
  display: block;
}

.acct-resetModal__title {
  margin: 0 0 8px;
  font-size: 24px;
  font-weight: 600;
  color: #eaecef;
}

body.light_theme .acct-resetModal__title {
  color: #101828;
}

.acct-resetModal__sub {
  margin: 10px 0 16px;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 500;
  color: #c2c2c2;
  max-width: 420px;
  margin-left: auto;
  margin-right: auto;
}

body.light_theme .acct-resetModal__sub {
  color: #6A7282;
}

.acct-resetModal__box {
  text-align: left;
  border: 1px solid #2b3139;
  border-radius: 10px;
  padding: 18px;
  background: #2b313980;
  margin-bottom: 18px;
  width: 505px;
  margin: 0 auto;
  margin-bottom: 24px;
}

body.light_theme .acct-resetModal__box {
  border: 1px solid #e5e7eb;
  background: #ffffff60;
}

.acct-resetModal__row {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  cursor: pointer;
  margin: 0;
}

.acct-resetModal__row input {
  margin-top: 2px;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  accent-color: #d1aa67;
}

body.light_theme .acct-resetModal__row input {
  accent-color: #303236;
}

.acct-resetModal__warnText {
  font-size: 14px;
  line-height: 1.45;
  color: #eaecef;
  font-weight: 400;
}

body.light_theme .acct-resetModal__warnText {
  color: #101828;
}

.acct-resetModal__actions {
  display: flex;
  gap: 12px;
  max-width: 510px;
  justify-content: center;
  margin: 0 auto;
}

.acct-resetModal__cancel {
  height: 46px;
  min-width: 160px;
  border-radius: 999px;
  border: none;
  background: #2b3139;
  color: #eaecef;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

body.light_theme .acct-resetModal__cancel {
  background: #DDDDDD;
  color: #374151;
}

.acct-resetModal__confirm {
  flex: 1 1;
  height: 46px;
  border-radius: 999px;
  border: none;
  background: #a3a3a3;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: not-allowed;
}

.acct-resetModal__confirm.is-enabled {
  background: #2d2e32;
  cursor: pointer;
}


@media (max-width: 991px) {
  .acct-page__title {
    font-size: 24px;
  }

  .acct-unavail__title {
    font-size: 24px;
  }

}

@media (max-width: 767px) {

  .acct-unavail__title {
    font-size: 22px;
  }

  .acct-page__title {
    font-size: 22px;
  }

  .acct-unavail__confirm {
    height: 42px;
    font-size: 14px;
  }

  .acct-modalOverlay {
    align-items: end;
  }

  .acct-resetModal__title {
    font-size: 22px;
  }

  .acct-resetModal__box {
    width: 100%;
    margin: 0 auto;
    margin-bottom: 20px;
  }

  .acct-resetModal {
    max-width: 100%;
    border-radius: 16px 16px 0px 0px;
    height: 80vh;
    overflow: scroll;
  }

  .acct-add__title {
    font-size: 22px;
  }

  .acct-add__submit {
    height: 42px;
    font-size: 14px;
  }

  .acct-emailModal {
    max-width: 100%;
    border-radius: 16px 16px 0px 0px;
  }

  .acct-emailModal__title {
    font-size: 20px;
  }

  .acct-emailModal__sub {
    font-size: 14px;
  }

  .acct-emailModal__submit {
    height: 42px;
    font-size: 14px;
    margin-top: 20px;
  }

  .acct-list {
    padding: 10px 0px;
  }

  .acct-card {
    flex-direction: column;
    align-items: stretch;
  }

  .acct-card__btn {
    width: 100%;
  }

  .acct-label {
    font-size: 14px;
  }

  .acct-emailModal__link {
    margin: 10px 0px;
    font-size: 14px;
  }



}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/TwofactorPage/accountConnections.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAEzC;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,0BAA0B;EAC1B,kCAAkC;EAClC,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;;AAGA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;;;AAIF","sourcesContent":["/* Account Connections — scoped .acct-* */\n\n.acct-page {\n  width: 100%;\n  min-height: 100%;\n  padding: 35px 24px 48px;\n  max-width: 1220px;\n  margin: 0 auto;\n}\n\n.acct-page *,\n.acct-page *::before,\n.acct-page *::after {\n  box-sizing: border-box;\n}\n\n.acct-page__crumbs {\n  margin-bottom: 18px;\n}\n\n.acct-page__crumbList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: #8e939c;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.acct-page__crumbItem--active {\n  color: #d9d9d9;\n  font-weight: 600;\n}\n\nbody.light_theme .acct-page__crumbItem--active {\n  color: #101828;\n}\n\n.acct-page__crumbSep {\n  color: #8e939c;\n}\n\n.acct-page__crumbLink {\n  border: none;\n  background: transparent;\n  padding: 0;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n}\n\n.acct-page__crumbLink:hover {\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.acct-page__title {\n  margin: 0 0 12px;\n  font-size: 36px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #e1e1e1;\n}\n\nbody.light_theme .acct-page__title {\n  color: #101828;\n}\n\n.acct-page__subtitle {\n  margin: -12px 0 22px;\n  font-size: 14px;\n  color: #8e939c;\n  font-weight: 500;\n  line-height: 1.5;\n}\n\n.acct-page__hint {\n  margin: -14px 0 18px;\n  font-size: 13px;\n  color: #8e939c;\n  line-height: 1.45;\n}\n\n.acct-page__banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin: -8px 0 20px;\n  padding: 12px 14px;\n  border-radius: 10px;\n  background: #fff7ed;\n  border: 1px solid #fed7aa;\n  color: #9a3412;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.acct-page__bannerBtn {\n  padding: 8px 14px;\n  border-radius: 8px;\n  border: 1px solid rgba(154, 52, 18, 0.35);\n  background: #fff;\n  color: #9a3412;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.acct-page__bannerBtn:hover {\n  background: #fffbeb;\n}\n\n/* Connection cards */\n.acct-list {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 30px 40px;\n}\n\n.acct-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 18px 20px;\n  border-radius: 12px;\n  background: #f5f6f70a;\n  border: 1px solid #eef2f61a;\n}\n\nbody.light_theme .acct-card {\n  background: #f5f6f7;\n  border: 1px solid #eef2f6;\n}\n\n.acct-card__left {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  min-width: 0;\n}\n\n.acct-card__logo {\n  width: 26px;\n  padding: 4px;\n  height: 26px;\n  flex-shrink: 0;\n  background-color: #E9E9E9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50px;\n}\n\n.acct-card__logo svg {\n  display: block;\n}\n\n.acct-card__body {\n  min-width: 0;\n}\n\n.acct-card__title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #e7e7e7;\n  margin: 0 0 4px;\n}\n\nbody.light_theme .acct-card__title {\n  color: #101828;\n}\n\n.acct-card__meta {\n  font-size: 12px;\n  font-weight: 500;\n  color: #6A7282;\n  margin: 0;\n}\n\n.acct-card__btn {\n  flex-shrink: 0;\n  height: 40px;\n  padding: 0 20px;\n  border-radius: 999px;\n  border: none;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.acct-card__btn--disconnect {\n  background: #e8eaed;\n  color: #101828;\n}\n\n.acct-card__btn--connect {\n  background: #2d2e32;\n  color: #ffffff;\n  font-weight: 500;\n}\n\n/* Select unavailable */\n.acct-unavail {\n  max-width: 560px;\n  margin: 0 auto;\n}\n\n.acct-unavail__title {\n  margin: 0 0 10px;\n  font-size: 36px;\n  font-weight: 600;\n  color: #f0f0f0;\n  text-align: left;\n}\n\nbody.light_theme .acct-unavail__title {\n  color: #101828;\n}\n\n.acct-unavail__sub {\n  margin: 0 0 22px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #84888C;\n  text-align: left;\n  line-height: 1.5;\n}\n\n.acct-unavail__choice {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 16px 18px;\n  background: #f3f4f61f;\n  border: 1px solid #e5e7eb6b;\n  border-radius: 10px;\n  cursor: pointer;\n  text-align: left;\n  margin-bottom: 16px;\n}\n\nbody.light_theme .acct-unavail__choice {\n  background: #f3f4f6;\n  border: 1px solid #e5e7eb;\n}\n\n.acct-unavail__choice.is-selected {\n  border-color: rgba(172, 138, 80, 0.45);\n}\n\n.acct-unavail__choiceLeft {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.acct-unavail__choiceIcon {\n  font-size: 22px;\n  color: #cfcfcf;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbody.light_theme .acct-unavail__choiceIcon {\n  color: #4a5565;\n}\n\n.acct-unavail__choiceTitle {\n  font-size: 14px;\n  font-weight: 700;\n  color: #f1f1f1;\n}\n\nbody.light_theme .acct-unavail__choiceTitle {\n  color: #101828;\n}\n\n.acct-unavail__choiceSub {\n  font-size: 12px;\n  color: #8e939c;\n  margin-top: 3px;\n}\n\n.acct-unavail__radio {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 2px solid #d1d5db;\n  background: #fff;\n  flex-shrink: 0;\n}\n\n.acct-unavail__choice.is-selected .acct-unavail__radio {\n  border-color: #101828;\n  box-shadow: inset 0 0 0 2px #101828;\n}\n\n.acct-unavail__confirm {\n  width: 100%;\n  height: 50px;\n  border-radius: 999px;\n  border: none;\n  background: #a3a3a3;\n  margin-top: 10px;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: not-allowed;\n}\n\n.acct-unavail__confirm.is-enabled {\n  background: #2d2e32;\n  cursor: pointer;\n}\n\n.acct-unavail__how {\n  display: block;\n  width: 100%;\n  margin-top: 20px;\n  border: none;\n  background: transparent;\n  font-size: 16px;\n  font-weight: 600;\n  color: #ac8a50;\n  /* text-decoration: underline; */\n  text-underline-offset: 3px;\n  cursor: pointer;\n}\n\n/* Add Email */\n.acct-add {\n  max-width: 560px;\n  margin: 0 auto;\n}\n\n.acct-add__title {\n  margin: 0 0 10px;\n  font-size: 28px;\n  font-weight: 700;\n  color: #f3f3f3;\n}\n\nbody.light_theme .acct-add__title {\n  color: #101828;\n}\n\n.acct-add__sub {\n  margin: 0 0 22px;\n  font-size: 14px;\n  color: #8e939c;\n  line-height: 1.5;\n}\n\n.acct-field {\n  margin-bottom: 18px;\n}\n\n.acct-label {\n  display: block;\n  font-size: 16px;\n  font-weight: 500;\n  color: #e0e0e0;\n  margin-bottom: 6px;\n}\n\nbody.light_theme .acct-label {\n  color: #101828;\n}\n\n.acct-inputWrap {\n  position: relative;\n}\n\n.acct-input {\n  width: 100%;\n  height: 48px;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb14;\n  background: #ffffff14;\n  padding: 0 14px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #e5e5e5;\n  outline: none;\n}\n\nbody.light_theme .acct-input {\n  border: 1px solid #e5e7eb;\n  background: #ffffff;\n  color: #101828;\n}\n\n.acct-input--code {\n  padding-right: 88px;\n}\n\n.acct-input::placeholder {\n  color: #9ca3af;\n}\n\n.acct-getCode {\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  border: none;\n  background: transparent;\n  font-size: 12px;\n  font-weight: 700;\n  color: #ac8a50;\n  cursor: pointer;\n}\n\n.acct-add__submit {\n  width: 100%;\n  height: 48px;\n  margin-top: 8px;\n  border: none;\n  border-radius: 999px;\n  background: #a3a3a3;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: not-allowed;\n}\n\n.acct-add__submit.is-enabled {\n  background: #2d2e32;\n  cursor: pointer;\n}\n\n/* Modals */\n.acct-modalOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgb(0 0 0 / 20%);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* padding: 18px; */\n  z-index: 100000030;\n}\n\nbody.light_theme .acct-modalOverlay {\n  background: rgb(255 255 255 / 20%);\n}\n\n.acct-emailModal {\n  width: 539px;\n  max-width: 92vw;\n  background: #1e2329;\n  border-radius: 14px;\n  border: 1px solid #2b3139;\n  box-shadow: 0 28px 60px rgba(0, 0, 0, 0.5);\n  padding: 22px 22px 0;\n  position: relative;\n  text-align: left;\n}\n\nbody.light_theme .acct-emailModal {\n  background: #fff;\n  border: 1px solid #E1E1E1;\n  box-shadow: 0 28px 60px rgba(15, 23, 42, 0.18);\n}\n\n.acct-emailModal__close {\n  position: absolute;\n  top: 14px;\n  right: 16px;\n  width: 34px;\n  height: 34px;\n  border: none;\n  background: transparent;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n  border-radius: 8px;\n  color: #eaecef;\n}\n\nbody.light_theme .acct-emailModal__close {\n  color: #111827;\n}\n\n.acct-emailModal__close:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\nbody.light_theme .acct-emailModal__close:hover {\n  background: rgba(17, 24, 39, 0.06);\n}\n\n.acct-emailModal__title {\n  margin: 0 0 8px;\n  padding-right: 40px;\n  font-size: 24px;\n  font-weight: 600;\n  color: #eaecef;\n}\n\nbody.light_theme .acct-emailModal__title {\n  color: #101828;\n}\n\n.acct-emailModal__sub {\n  margin: 0 0 18px;\n  font-size: 16px;\n  line-height: 1.45;\n  font-weight: 500;\n  color: #84888C;\n}\n\nbody.light_theme .acct-emailModal__sub {\n  color: #6A7282;\n}\n\n.acct-emailModal__submit {\n  width: 100%;\n  height: 50px;\n  border: none;\n  border-radius: 999px;\n  background: #a3a3a3;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: not-allowed;\n  margin-top: 26px;\n}\n\n.acct-emailModal__submit.is-enabled {\n  background: #2d2e32;\n  cursor: pointer;\n}\n\n.acct-emailModal__link {\n  display: block;\n  width: 100%;\n  margin: 20px 0 20px;\n  border: none;\n  background: transparent;\n  text-align: center;\n  font-size: 15px;\n  font-weight: 500;\n  color: #ac8a50;\n  /* text-decoration: underline; */\n  text-underline-offset: 3px;\n  cursor: pointer;\n}\n\n.acct-emailModal__footer {\n  border-top: 1px solid #2b3139;\n  padding: 14px 0 16px;\n  margin: 0 -22px;\n  padding-left: 22px;\n  padding-right: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  font-size: 14px;\n  color: #9ca3af;\n  font-weight: 500;\n}\n\nbody.light_theme .acct-emailModal__footer {\n  border-top-color: #f4f4f4;\n}\n\n.acct-emailModal__footerIcon {\n  width: 18px;\n  height: 18px;\n  display: block;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n/* Confirm reset modal */\n.acct-resetModal {\n  width: 628px;\n  max-width: 92vw;\n  background: #1e23297d;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  border-radius: 16px;\n  border: 1px solid #2b3139;\n  box-shadow: 0 28px 60px rgba(0, 0, 0, 0.5);\n  padding: 22px 24px 22px;\n  position: relative;\n  text-align: center;\n}\n\nbody.light_theme .acct-resetModal {\n  background: rgb(255 255 255 / 20%);\n  border: 1px solid #E1E1E1;\n  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);\n}\n\n.acct-resetModal__close {\n  position: absolute;\n  top: 12px;\n  right: 14px;\n  width: 34px;\n  height: 34px;\n  border: none;\n  background: transparent;\n  font-size: 22px;\n  cursor: pointer;\n  border-radius: 8px;\n  color: #eaecef;\n}\n\nbody.light_theme .acct-resetModal__close {\n  color: #111827;\n}\n\n.acct-resetModal__close:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\nbody.light_theme .acct-resetModal__close:hover {\n  background: rgba(17, 24, 39, 0.06);\n}\n\n.acct-resetModal__art {\n  margin: 8px auto 14px;\n  max-width: 200px;\n}\n\n.acct-resetModal__art img,\n.acct-resetModal__art svg {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.acct-resetModal__title {\n  margin: 0 0 8px;\n  font-size: 24px;\n  font-weight: 600;\n  color: #eaecef;\n}\n\nbody.light_theme .acct-resetModal__title {\n  color: #101828;\n}\n\n.acct-resetModal__sub {\n  margin: 10px 0 16px;\n  font-size: 14px;\n  line-height: 1.5;\n  font-weight: 500;\n  color: #c2c2c2;\n  max-width: 420px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\nbody.light_theme .acct-resetModal__sub {\n  color: #6A7282;\n}\n\n.acct-resetModal__box {\n  text-align: left;\n  border: 1px solid #2b3139;\n  border-radius: 10px;\n  padding: 18px;\n  background: #2b313980;\n  margin-bottom: 18px;\n  width: 505px;\n  margin: 0 auto;\n  margin-bottom: 24px;\n}\n\nbody.light_theme .acct-resetModal__box {\n  border: 1px solid #e5e7eb;\n  background: #ffffff60;\n}\n\n.acct-resetModal__row {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  cursor: pointer;\n  margin: 0;\n}\n\n.acct-resetModal__row input {\n  margin-top: 2px;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  accent-color: #d1aa67;\n}\n\nbody.light_theme .acct-resetModal__row input {\n  accent-color: #303236;\n}\n\n.acct-resetModal__warnText {\n  font-size: 14px;\n  line-height: 1.45;\n  color: #eaecef;\n  font-weight: 400;\n}\n\nbody.light_theme .acct-resetModal__warnText {\n  color: #101828;\n}\n\n.acct-resetModal__actions {\n  display: flex;\n  gap: 12px;\n  max-width: 510px;\n  justify-content: center;\n  margin: 0 auto;\n}\n\n.acct-resetModal__cancel {\n  height: 46px;\n  min-width: 160px;\n  border-radius: 999px;\n  border: none;\n  background: #2b3139;\n  color: #eaecef;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\nbody.light_theme .acct-resetModal__cancel {\n  background: #DDDDDD;\n  color: #374151;\n}\n\n.acct-resetModal__confirm {\n  flex: 1;\n  height: 46px;\n  border-radius: 999px;\n  border: none;\n  background: #a3a3a3;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: not-allowed;\n}\n\n.acct-resetModal__confirm.is-enabled {\n  background: #2d2e32;\n  cursor: pointer;\n}\n\n\n@media (max-width: 991px) {\n  .acct-page__title {\n    font-size: 24px;\n  }\n\n  .acct-unavail__title {\n    font-size: 24px;\n  }\n\n}\n\n@media (max-width: 767px) {\n\n  .acct-unavail__title {\n    font-size: 22px;\n  }\n\n  .acct-page__title {\n    font-size: 22px;\n  }\n\n  .acct-unavail__confirm {\n    height: 42px;\n    font-size: 14px;\n  }\n\n  .acct-modalOverlay {\n    align-items: end;\n  }\n\n  .acct-resetModal__title {\n    font-size: 22px;\n  }\n\n  .acct-resetModal__box {\n    width: 100%;\n    margin: 0 auto;\n    margin-bottom: 20px;\n  }\n\n  .acct-resetModal {\n    max-width: 100%;\n    border-radius: 16px 16px 0px 0px;\n    height: 80vh;\n    overflow: scroll;\n  }\n\n  .acct-add__title {\n    font-size: 22px;\n  }\n\n  .acct-add__submit {\n    height: 42px;\n    font-size: 14px;\n  }\n\n  .acct-emailModal {\n    max-width: 100%;\n    border-radius: 16px 16px 0px 0px;\n  }\n\n  .acct-emailModal__title {\n    font-size: 20px;\n  }\n\n  .acct-emailModal__sub {\n    font-size: 14px;\n  }\n\n  .acct-emailModal__submit {\n    height: 42px;\n    font-size: 14px;\n    margin-top: 20px;\n  }\n\n  .acct-list {\n    padding: 10px 0px;\n  }\n\n  .acct-card {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .acct-card__btn {\n    width: 100%;\n  }\n\n  .acct-label {\n    font-size: 14px;\n  }\n\n  .acct-emailModal__link {\n    margin: 10px 0px;\n    font-size: 14px;\n  }\n\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
